<template>
  <div>
    <v-row class="mt-1" v-for="item in user" :key="item.id">
      <v-col cols="12" md="6" class="px-1">
        <v-card rounded="lg" class="mx-5">
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="../assets/captain.jpeg"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ item.bio }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="pa-3">
           <v-row justify="space-around" align="space-around">
              <div>
                <div>
                  <img
                    src="../assets/ex.jpg"
                    alt=""
                    class="rounded-lg mx-1"
                    width="120"
                    height="70"
                  />
                </div>
                <div>
                  <img
                    src="../assets/ex.jpg"
                    alt=""
                    class="rounded-lg mx-1"
                    width="120"
                    height="70"
                  />
                </div>
                <div>
                  <img
                    src="../assets/ex.jpg"
                    alt=""
                    class="rounded-lg mx-1"
                    width="120"
                    height="70"
                  />
                </div>
              </div>

              <div>
                <p class="icon-text">
                  <v-icon color="#f69227" left>mdi-phone</v-icon>
                  {{ item.phone }}
                </p>
                <p class="icon-text text-wrap">
                  <v-icon color="#f69227" left>mdi-email</v-icon>
                  {{ item.email }}
                </p>
                <p class="icon-text">
                  <v-icon color="#f69227" left>mdi-medical-bag</v-icon>
                  {{ item.work }}
                </p>
                <p class="icon-text">
                  <v-icon color="#f69227" left>mdi-google-maps</v-icon>
                  {{ item.city }}
                </p>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="px-1">
        <v-card rounded="lg" class="mx-5">
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="../assets/captain.jpeg"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ item.bio }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="pa-3">
            <v-row justify="space-around" align="space-around">
              <div>
                <div>
                  <img
                    src="../assets/ex.jpg"
                    alt=""
                    class="rounded-lg mx-1"
                    width="120"
                    height="70"
                  />
                </div>
                <div>
                  <img
                    src="../assets/ex.jpg"
                    alt=""
                    class="rounded-lg mx-1"
                    width="120"
                    height="70"
                  />
                </div>
                <div>
                  <img
                    src="../assets/ex.jpg"
                    alt=""
                    class="rounded-lg mx-1"
                    width="120"
                    height="70"
                  />
                </div>
              </div>

              <div>
                <p class="icon-text">
                  <v-icon color="#f69227" left>mdi-phone</v-icon>
                  {{ item.phone }}
                </p>
                <p class="icon-text text-wrap">
                  <v-icon color="#f69227" left>mdi-email</v-icon>
                  {{ item.email }}
                </p>
                <p class="icon-text">
                  <v-icon color="#f69227" left>mdi-medical-bag</v-icon>
                  {{ item.work }}
                </p>
                <p class="icon-text">
                  <v-icon color="#f69227" left>mdi-google-maps</v-icon>
                  {{ item.city }}
                </p>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data: () => ({
    user: [
      {
        id: "1",
        name: "john doe",
        bio: "I’m a software developer  and I love Solving problems",
        phone: "07016505825",
        email: "johndoe@gmail.com",
        work: "Kad Ict Hub",
        city: "Kaduna Nigeria",
      },
      {
        id: "2",
        name: "john doe",
        bio: "I’m a software developer  and I love Solving problems",
        phone: "07016505825",
        email: "johndoe@gmail.com",
        work: "Kad Ict Hub",
        city: "Kaduna Nigeria",
      },
      {
        id: "3",
        name: "john doe",
        bio: "I’m a software developer  and I love Solving problems",
        phone: "07016505825",
        email: "johndoe@gmail.com",
        work: "Kad Ict Hub",
        city: "Kaduna Nigeria",
      },
    ],
  }),
};
</script>
